import { inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { HdContentLanguageService } from '../../chart/bodygraph/hd-content-language.service';

export type IChingTranslate = (key: string, params?: Record<string, unknown>) => string;

/**
 * Vertaalfunctie voor de raadpleegcomponenten: volgt de HD-content-taal (en
 * tikt mee met vertaling-loads), zoals het Classic I Ching-paneel. Aanroepen
 * in een injectiecontext (veldinitialisatie).
 */
export function injectIChingTranslate(): IChingTranslate {
  const transloco = inject(TranslocoService);
  const contentLang = inject(HdContentLanguageService);
  return (key, params) => {
    contentLang.translationsLoadedTick();
    return transloco.translate<string>(key, params, contentLang.effectiveLang());
  };
}
